
import { getSumOfAddOn, getSumOfOptions, getSumOfSelectedCategory } from "../helper";
import Konsole from "../konsole/Konsole";
import { ReturnPrice } from "../orderUtils/OrderUtils";
// @@ set price 0 if item for meal

export function PriceReturnForMeal(isMeal: any, price: any) {
    let rPrice = price;
    // if (CheckIsMeal(isMeal)) {
    //     rPrice = 0;
    // }
    return rPrice;
}

//  check item is meal or not
export function CheckIsMeal(id: any) {
    return id == 1;
}




// @@Calculate meal Sub price
export const GetMealSubTotalPrice = (mealData: any, meal: any) => {
    //Konsol.log('GetMealSubTotalPrice', mealData, meal);
    let item = structuredClone(meal);

    let price = ReturnPrice(mealData);
    if (meal?.length > 0) {
        // let selectedMealItem
        let selectedMealItems: any = [];

        item?.forEach((curr: any) => {
            if (curr?.selectedMealItem?.length > 0) {
                selectedMealItems.push(...curr.selectedMealItem);  // Spread to add individual elements instead of an array
            }
        });

        // //Konsole.log('selectedMealItemsselectedMealItems',selectedMealItems)

        let selectedItemPrice = selectedMealItems?.reduce((price: any, curr: any) => {
            let selectedCatPrice = getSumOfSelectedCategory(curr?.selectedCategory)
            let selectedOpPrice = getSumOfOptions(curr?.selectedoptions)
            let addOnsPrice = getSumOfAddOn(curr.selected_addOn)
            price += ((selectedCatPrice || 0) + (selectedOpPrice || 0) + (curr?.offered_price || 0) + (addOnsPrice || 0))
            return price;

        }, 0)
        //Konsole.log('selectedItemPrice',price,selectedItemPrice)
        price += selectedItemPrice;

        return price || 0
    }
}